// Quote Generator domain — service-catalogue quote → eSignable → matter.
import { API } from './_client';

export const quotes = {
  list: (opts = {}) => API.get('/quotes', { params: opts }).then((r) => r.data),
  get: (id) => API.get(`/quotes/${id}`).then((r) => r.data),
  create: (payload) => API.post('/quotes', payload).then((r) => r.data),
  update: (id, patch) => API.patch(`/quotes/${id}`, patch).then((r) => r.data),
  remove: (id) => API.delete(`/quotes/${id}`).then((r) => r.data),
  send: (id) => API.post(`/quotes/${id}/send`).then((r) => r.data),
  convert: (id) => API.post(`/quotes/${id}/convert`).then((r) => r.data),
  markSigned: (id) => API.post(`/quotes/${id}/mark-signed`).then((r) => r.data),
  previewHtmlAuthed: (id) => API.get(`/quotes/${id}/preview.html`, { responseType: 'text' }).then((r) => r.data),
};
